import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ExclusiveModal from "../common/exclusive-modal";
import { getItem } from "../../services/common/utils";
import { SELECTED_LANG } from "../../services/common/Constants";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSelectedMenu, setSelectedMenuPrev } from "../../reducer/actions";

const Footer = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [deeplinktext, setDeeplinktext] = useState("");
  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const [shopUrl, setshopUrl] = useState("");
  const tokenid = useSelector((state) => state?.userdata?.value?.tokenid);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const selectorMenu = useSelector(
    (state) => state?.userdata?.value?.SelectedMenu
  );
  console.log("====SelectedMenu=====>", selectorMenu);

  try {
    useEffect(() => {
      (async () => {
        var _lang = await getItem(SELECTED_LANG);
        if (_lang == "en") {
          setshopUrl("https://shop.ooredoo.com.kw/EN/");
        } else {
          setshopUrl("https://shop.ooredoo.com.kw/AR/");
        }
      })();
    }, []);
  } catch {}

  const deeplinkclick = (type) => {
    setDeeplinktext(type);
    setShowModal(!showModal);
  };

  const locationArray = ["home/index", "home", "paybill", "nojoom", "moremenu", "more"]
  const homeMenuActivePaths = ['/manage-account'];

  useEffect(() => {
    if(locationArray.includes(location.pathname)){
      dispatch(setSelectedMenu(location.pathname));
    }

    if(homeMenuActivePaths.includes(location.pathname)){
      dispatch(setSelectedMenu('/home'));
    }
  }, [location]);


  // const clickRedirection = (params) => {
  //   console.log(`Redirection to component page`);
  //   dispatch(setSelectedMenuPrev(selectorMenu));
  //   dispatch(setSelectedMenu(params));
  //   console.log("MenuParam", params);
  //   //navigate("/" + params);
  // };

  console.log(selectorMenu, "selectorMenueeee")

  return (
    <>
      <section className="footer_menu">
        <div className="fixed_footer_container">
          {tokenid !== null && tokenid?.length > 0 ? (
            <NavLink
             // onClick={(e) => {
              //   clickRedirection("home/index");
              // }}
              className={(selectorMenu === "/home/index" || selectorMenu === "/home") ? "footer_menu_item active"  :"footer_menu_item" }
              to="/home/index"
              activeclassname="active"
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/home_red.svg"}
                className="red_icon"
                alt=""
                title=""
              />
              <img
                src={process.env.PUBLIC_URL + "/assets/images/home_gray.svg"}
                className="gray_icon"
                alt=""
                title=""
              />
              <span>{t("home")}</span>
            </NavLink>
          ) : (
            <Link  className={selectorMenu === "/home/index" ? "footer_menu_item active" : "footer_menu_item" } to="" activeclassname="active">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/home_red.svg"}
                className="red_icon"
                alt=""
                title=""
              />
              <img
                src={process.env.PUBLIC_URL + "/assets/images/home_gray.svg"}
                className="gray_icon"
                alt=""
                title=""
              />
              <span>{t("home")}</span>
            </Link>
          )}
          <NavLink
           className={selectorMenu === "/paybill" ? "footer_menu_item active"  :"footer_menu_item" }
            to="/paybill"
            activeclassname="active"
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/pay_red.svg"}
              className="red_icon"
              alt=""
              title=""
            />
            <img
              src={process.env.PUBLIC_URL + "/assets/images/pay_gray.svg"}
              className="gray_icon"
              alt=""
              title=""
            />
            <span>{t("pay")}</span>
          </NavLink>

          <a className="footer_menu_item" href={shopUrl} target="blank">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/shop_red.svg"}
              className="red_icon"
              alt=""
              title=""
            />
            <img
              src={process.env.PUBLIC_URL + "/assets/images/shop_gray.svg"}
              className="gray_icon"
              alt=""
              title=""
            />
            <span>{t("shop")}</span>
          </a>

          <NavLink
           
            to="/nojoom"
            className={selectorMenu === "/nojoom" ? "footer_menu_item active"  :"footer_menu_item" }
            activeclassname="active"
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/nojoom_red.svg"}
              className="red_icon"
              alt=""
              title=""
            />
            <img
              src={process.env.PUBLIC_URL + "/assets/images/nojoom_gray.svg"}
              className="gray_icon"
              alt=""
              title=""
            />
            <span>{t("nojoom")}</span>
          </NavLink>

          <NavLink
           
            // to="/moremenu"
            to="/more"
            // className={selectorMenu === "/moremenu" ? "footer_menu_item active"  :"footer_menu_item" }
            className={selectorMenu === "/more" ? "footer_menu_item active"  :"footer_menu_item" }
            activeclassname="active"
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/more_red.svg"}
              className="red_icon"
              alt=""
              title=""
            />
            <img
              src={process.env.PUBLIC_URL + "/assets/images/more_gray.svg"}
              className="gray_icon"
              alt=""
              title=""
            />
            <span>{t("more")}</span>
          </NavLink>
        </div>
      </section>
      <ExclusiveModal
        show={showModal}
        toggleModal={toggleModal}
        deeplinktext={deeplinktext}
      />
    </>
  );
};
export default Footer;
